const cards = [
  {
    title: '异界触手录',
    desc: '普通高中生穿越异世界，觉醒触手之力，在魔法与剑的世界中展开惊心动魄的冒险旅程。',
    rating: '9.5',
    tag: '异世界冒险',
    views: '128.6万',
    image: 'https://readdy.ai/api/search-image?query=A%20stunning%20manga%20style%20illustration%20of%20a%20teenage%20hero%20with%20glowing%20tentacle-like%20energy%20in%20a%20fantasy%20world%2C%20magical%20atmosphere%20with%20sparkling%20particles%2C%20warm%20coral%20and%20gold%20color%20scheme%2C%20dramatic%20composition%2C%20anime%20art%20style%2C%20clean%20simple%20background%2C%20professional%20illustration&width=400&height=560&seq=card-manga-01&orientation=portrait',
  },
  {
    title: '触手都市',
    desc: '现代都市中隐藏着触手生物的秘密，一位普通上班族意外卷入超自然事件，揭开城市背后的真相。',
    rating: '9.2',
    tag: '都市奇幻',
    views: '115.2万',
    image: 'https://readdy.ai/api/search-image?query=A%20manga%20style%20illustration%20of%20a%20mysterious%20urban%20scene%20with%20shadowy%20tentacle%20silhouettes%20wrapping%20around%20skyscrapers%20at%20night%2C%20neon%20city%20lights%2C%20atmospheric%20noir%20vibe%2C%20warm%20amber%20and%20deep%20red%20tones%2C%20dramatic%20contrast%2C%20anime%20urban%20fantasy%20style&width=400&height=560&seq=card-manga-02&orientation=portrait',
  },
  {
    title: '触手纪元',
    desc: '未来世界，人类与触手生命体共存。机甲与触手科技的碰撞，谱写科幻史诗新篇章。',
    rating: '9.3',
    tag: '科幻机甲',
    views: '98.7万',
    image: 'https://readdy.ai/api/search-image?query=A%20futuristic%20manga%20illustration%20of%20a%20mecha%20warrior%20integrated%20with%20organic%20tentacle-like%20biotechnology%2C%20sci-fi%20cityscape%20background%2C%20holographic%20displays%2C%20warm%20metallic%20coral%20and%20copper%20tones%2C%20action%20pose%2C%20detailed%20mechanical%20design%2C%20anime%20sci-fi%20style&width=400&height=560&seq=card-manga-03&orientation=portrait',
  },
  {
    title: '暗夜触手',
    desc: '深夜的校园中流传着诡异传说。一群学生发现隐藏在黑暗中的触手秘密，悬疑层层递进。',
    rating: '9.1',
    tag: '悬疑惊悚',
    views: '87.3万',
    image: 'https://readdy.ai/api/search-image?query=A%20dark%20atmospheric%20manga%20illustration%20of%20a%20mysterious%20school%20corridor%20at%20night%20with%20eerie%20tentacle%20shadows%20creeping%20along%20walls%2C%20moonlight%20streaming%20through%20windows%2C%20suspenseful%20horror%20vibe%2C%20deep%20red%20and%20dark%20amber%20tones%2C%20thriller%20anime%20art%20style&width=400&height=560&seq=card-manga-04&orientation=portrait',
  },
  {
    title: '触手学园',
    desc: '在一所特殊的学校里，学生们与触手伙伴共同成长。搞笑温馨的校园日常，治愈你的每一天。',
    rating: '8.9',
    tag: '校园搞笑',
    views: '76.1万',
    image: 'https://readdy.ai/api/search-image?query=A%20cheerful%20manga%20illustration%20of%20students%20in%20school%20uniforms%20with%20friendly%20cartoonish%20tentacle%20companions%2C%20bright%20sunny%20classroom%20setting%2C%20warm%20and%20playful%20atmosphere%2C%20soft%20coral%20and%20cream%20color%20palette%2C%20comedy%20slice-of-life%20anime%20style&width=400&height=560&seq=card-manga-05&orientation=portrait',
  },
  {
    title: '触手物语',
    desc: '小镇少女与神秘触手生物的温暖邂逅，一段关于友情与成长的美好故事，触手漫画中的治愈清流。',
    rating: '8.8',
    tag: '温馨日常',
    views: '65.4万',
    image: 'https://readdy.ai/api/search-image?query=A%20gentle%20and%20heartwarming%20manga%20illustration%20of%20a%20young%20girl%20in%20a%20small%20countryside%20town%20with%20a%20soft%20ethereal%20tentacle-like%20spirit%20companion%2C%20cherry%20blossom%20petals%20drifting%2C%20warm%20golden%20sunset%20lighting%2C%20pastel%20coral%20and%20cream%20tones%2C%20wholesome%20slice-of-life%20anime%20style&width=400&height=560&seq=card-manga-06&orientation=portrait',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-16 md:py-20 scroll-mt-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-3">
          精选推荐
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          触手漫画编辑团队为你精选的高分佳作
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cards.map((card) => (
            <a
              key={card.title}
              href="#ranking"
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-colors cursor-pointer"
            >
              <div className="relative aspect-[3/4] overflow-hidden">
                <img
                  src={card.image}
                  alt={`${card.title} - 触手漫画精选推荐`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-0.5 bg-primary-500 text-background-50 text-xs font-medium rounded-full whitespace-nowrap">
                    {card.tag}
                  </span>
                </div>
                <div className="absolute top-3 right-3 flex items-center gap-1 bg-background-50/90 backdrop-blur-sm rounded-full px-2 py-0.5">
                  <i className="ri-star-fill text-accent-500 text-xs"></i>
                  <span className="text-xs font-bold text-foreground-800">{card.rating}</span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-base font-heading font-bold text-foreground-900 mb-1 group-hover:text-primary-500 transition-colors">
                  {card.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed mb-3 line-clamp-2">
                  {card.desc}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-400 flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {card.views}
                  </span>
                  <span className="text-xs text-primary-500 font-medium whitespace-nowrap">
                    立即阅读 →
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}